// Source:  http://stackoverflow.com/questions/36366319/angular-strip-all-tags-from-inputs
export function RemoveTags() {
    'ngInject';
    return (input) => {
        return input.replace(/<[^>]+>/g, '');
    }
} 


// WEBPACK FOOTER //
// ./src/app/shared/filters/RemoveTags.js